module.exports = __webpack_public_path__ + "img/1217.fe77ce66.png";